import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'checkbox-renderer',
  template: `
    <input
      type="checkbox"
      (change)="onChange($event)"
      [checked]="params.value"
      [disabled]="params.data?.disabledCheckbox"
    />
  `
})
export class CheckboxRenderer implements ICellRendererAngularComp {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  onChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    const colId = this.params.column.colId;
    this.params.node.setDataValue(colId, checked);
  }

  refresh(): boolean {
    return true; // Indicate that the cell was refreshed
  }
}
